import React, { useState, useEffect } from "react";
import { Table, Badge } from "react-bootstrap";
import Api from "../../utils/Api";
import { useMediaQuery } from "react-responsive";
import moment from "moment";

export default function BackupLogs() {
    const [logs, setLogs] = useState([]);
    const isMobile = useMediaQuery({ query: "(max-width: 599px)" });

    useEffect(() => {
        loadLogs();
    }, []);

    const loadLogs = async () => {
        const { response } = await Api.backupLogs();
        setLogs(response);
    };

    const statusBadge = (status) => {
        const variant = {
            SUCCESS: "success",
            FAIL: "danger",
            RUNNING: "warning"
        };
        return <Badge bg={variant[status] || "secondary"}>{status}</Badge>;
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return "-";
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: isMobile ? "95%" : "50%",
        margin: "auto"
    };

    return (
        <div>
            <div style={cardStyle}>
                <Table style={{ width: "90%", margin: "auto" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "180px" }}>זמן התחלה</th>
                            <th style={{ width: "100px" }}>סטטוס</th>
                            <th style={{ width: "100px" }}>משך</th>
                            <th style={{ width: "100px" }}>גודל קובץ</th>
                            <th style={{ width: "100px" }}>מייל נשלח</th>
                            {!isMobile && <th>שגיאה</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map((log) => {
                            const startTime = moment(log.startTime).format("DD-MM-YY HH:mm:ss");
                            const duration = log.duration != null
                                ? `${(log.duration / 60).toFixed(2)} דקות`
                                : "-";

                            return (
                                <tr key={log.id}>
                                    <td>{startTime}</td>
                                    <td>{statusBadge(log.status)}</td>
                                    <td>{duration}</td>
                                    <td>{formatFileSize(log.fileSize)}</td>
                                    <td>{log.emailSent ? "✓" : "✗"}</td>
                                    {!isMobile && (
                                        <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {log.error || "-"}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                        {logs.length === 0 && (
                            <tr>
                                <td colSpan={isMobile ? 5 : 6} style={{ textAlign: "center", padding: "20px" }}>
                                    אין לוגים
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}
